import React, { useState } from "react";
import "./styles.scss";
import axios from "axios";
import { Loader } from "react-bootstrap-typeahead";
import { toast } from "react-toastify";

interface IPROPS {
    onClose: any;
    serviceData: any;
    fetchServiceRequestAPI: any;
    selectedTab
}

const CancelRequest: React.FC<IPROPS> = ({
    onClose,
    serviceData,
    fetchServiceRequestAPI,
    selectedTab
}) => {
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const [loading, setLoading]  =useState(false)


    console.log(serviceData, "serviceDattata")

    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;
    const token = localStorage.getItem("customer-token");

   const handleSave = async () => {
    const url = `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/booking-requests/${selectedTab === "scheduled" ? serviceData?.request_id : serviceData?.id}/cancel/`;
    console.log("URL:", url);

    try {
        setLoading(true)

        const response = await axios.post(url, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (response?.data) {
            // fetchServiceRequestAPI()
            onClose()
            toast.success("Request cancelled successfully")

        }
        console.log("Response:", response?.data);
        // onClose(); fetchServiceRequestAPI();
    } catch (err) {
        console.error("Error:", err);
        toast.error("An error occured")
    }
    finally {
        setLoading(false)
    }
};
                             
    return (
        <div
            className="customer-vehicle-info__modal-overlay"
            onClick={handleOverlayClick}
        >
            <div className="customer-vehicle-info__modal" style={{width: "600px"}}>
                <div
                    className="customer-vehicle-info__modal-header"
                    style={{
                        borderBottom: "none",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <h2
                        className="customer-vehicle-info__modal-title"
                        style={{ color: "black", fontFamily: "Karbon-medium", marginBottom: "0", paddingBottom: "0" }}
                    > 
                        Are you sure you want to cancel this service?
                    </h2>
                </div>

                <div
                    className="customer-vehicle-info__modal-footer"
                    style={{ border: "none" }}
                >
                    <button
                        className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--save"
                        style={{
                            borderRadius: "20px",
                            background: "#ff6b35",
                            color: "white",
                            fontFamily: "Karbon-medium"
                        }}
                        onClick={handleSave}
                    >
                        {loading ? <>Confirming...<Loader /></> : "Confirm"}
                        
                    </button>
                    <button
                        className="customer-vehicle-info__modal-btn vehicle-info__modal-btn--cancel"
                        onClick={onClose}
                        
                        style={{ borderRadius: "20px", fontFamily: "Karbon-medium"
                         }}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelRequest;
